<div class="movements-usa">
  <div class="movements-usa__search-container">
    <hb-datetime-range-picker
      [defaultStartDate]="defaultStartDate"
      [defaultEndDate]="defaultEndDate"
      (onDateRangeChanged)="handleDateRangeChange($event)"
    ></hb-datetime-range-picker>
  </div>

  <div class="table-grid-nvo">
    <ul class="header-grid">
      <li class="li-text-format">Fecha</li>
      <li class="li-text-format">Hora</li>
      <li class="li-text-format">Emisora</li>
      <li class="li-text-format">Sentido</li>
      <li class="li-text-format">Títulos</li>
      <li class="li-text-format">Precio</li>
      <li class="li-text-format">Monto</li>
    </ul>
    <div class="body-grid" *ngIf="!(showSkeleton$ | async)">
      <ul
        *ngFor="
          let transaction of transactions;
          let index = index;
          let odd = odd;
          let even = even
        "
        class="row-grid"
      >
        <li class="li-text-format">
          <span>{{ transaction.date }}</span>
        </li>
        <li class="li-text-format">
          <span>{{ transaction.hour }}</span>
        </li>
        <li class="li-text-format">
          <span>{{ transaction.instrument.symbol }}</span>
        </li>
        <li class="li-text-format">
          <span>
            {{ transaction.type }}
          </span>
        </li>
        <li class="li-text-format">
          <span data-recording-sensitive>
            {{ transaction.quantity | hbCustomFormat: '0,0.00000000' }}
          </span>
        </li>
        <li class="li-text-format">
          <span>
            {{
              transaction.price
                | hbCustomFormat
                  : (transaction.price < 1 ? '$0,0[.]00[0]' : '$0,0[.]00')
            }}
          </span>
        </li>
        <li class="li-text-format">
          <span data-recording-sensitive>
            {{
              transaction.amount
                | hbCustomFormat
                  : (transaction.amount < 1 ? '$0,0[.]00[0]' : '$0,0[.]00')
            }}
          </span>
        </li>
      </ul>
      <div
        class="none-rows"
        *ngIf="transactions.length <= 0 && !(showSkeleton$ | async)"
      >
        <i class="icon icon-atm-icn-ordenes"></i>
        <div *ngIf="!requestFailed">
          No se han encontrado transacciones, intenta con un intervalo nuevo.
        </div>
        <div *ngIf="requestFailed">
          Ocurrió un error al tratar de obtener las transacciones. Intenta de
          nuevo más tarde.
        </div>
      </div>
    </div>
    <div class="body-grid" *ngIf="showSkeleton$ | async">
      <ul *ngFor="let tr of emptyState" class="row-grid">
        <li class="li-text-format">
          <span class="skeleton"></span>
        </li>
        <li class="li-text-format">
          <span class="skeleton"></span>
        </li>
        <li class="li-text-format">
          <span class="skeleton"></span>
        </li>
        <li class="li-text-format">
          <span class="skeleton"></span>
        </li>
        <li class="li-text-format">
          <span class="skeleton"></span>
        </li>
        <li class="li-text-format">
          <span class="skeleton"></span>
        </li>
        <li class="li-text-format">
          <span class="skeleton"></span>
        </li>
        <li class="li-text-format">
          <span class="skeleton"></span>
        </li>
      </ul>
    </div>
  </div>

  <div class="movements-usa__pagination-container" *ngIf="pagination">
    <span class="movements-usa__pagination-indicator">
      {{ pagination.page }} / {{ pagination.totalPages }} registros.
    </span>
    <a
      class="movements-usa__pagination-button"
      (click)="getNextPage()"
      [ngClass]="{
        'movements-usa__pagination-button--disabled': !pagination.next
      }"
    >
      Mostrar más
    </a>
  </div>
</div>
